import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('sale_documents', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        show: (cntx, { id }) => {
            axios.get(`sale_documents/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        create: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('sale_documents', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        printDoc: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('sale_reports', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        requisition: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('notes', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        update: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`sale_documents/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        sale: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`sales/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`sale_documents/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        seasons: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('seasons', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        buyers: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('buyers', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        societies: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('societies', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        transporters: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('transporters', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        markets: (cntx, params) => {
            console.log(params)
            return new Promise((resolve, reject) => {
                axios.get('markets', { params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        sales: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('sales', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        grades: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('grades', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        growers: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('growers', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        locations: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('locations', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        registrationNumbers: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('registration_numbers', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
